import { render, staticRenderFns } from "./Location.vue?vue&type=template&id=3151ad05&scoped=true"
import script from "./Location.vue?vue&type=script&lang=js"
export * from "./Location.vue?vue&type=script&lang=js"
import style0 from "./Location.vue?vue&type=style&index=0&id=3151ad05&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3151ad05",
  null
  
)

export default component.exports